module.exports = __webpack_public_path__ + "static/media/by.f4cbd761.svg";